import { types } from "@/BaseComponent";
import { apiService, header } from "@/services/interceptor";
import { AxiosResponse } from "axios";

export default {
    async user(param: types.ReqParamForAdmin): Promise<types.ResStatisticsForUser> {
        const res = {} as types.ResStatisticsForUser;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/statistics/user", param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async reportCommon(param: types.ReqParamForAdmin): Promise<types.ResStatisticsForReport> {
        const res = {} as types.ResStatisticsForReport;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/statistics/report/common", param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async reportDetail(type: number, param: types.ReqStatisticsForReport): Promise<types.ResStatisticsForReport> {
        const res = {} as types.ResStatisticsForReport;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(`/statistics/report/${type}/detail`, param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },
    async board(param: types.ReqBoardListForActivityManage): Promise<types.ResStatisticsForBoard> {
        const res = {} as types.ResStatisticsForBoard;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/statistics/board", param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async userExportExcel(param: types.ReqParamForDashboard): Promise<any> {
        let res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response: AxiosResponse<Blob> = await apiService().post("/statistics/user/excel/download", param, {
                withCredentials: false,
                responseType: "blob",
            });

            return response;
        } catch (error: any) {
            console.error(error);
            res = error.response.data;
        }
        return res;
    },

    async reportExportExcel(param: types.ReqParamForDashboard): Promise<any> {
        let res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response: AxiosResponse<Blob> = await apiService().post("/statistics/report/excel/download", param, {
                withCredentials: false,
                responseType: "blob",
            });

            return response;
        } catch (error: any) {
            console.error(error);
            res = error.response.data;
        }
        return res;
    },

    async boardExportExcel(param: types.ReqParamForDashboard): Promise<any> {
        let res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response: AxiosResponse<Blob> = await apiService().post("/statistics/board/excel/download", param, {
                withCredentials: false,
                responseType: "blob",
            });

            return response;
        } catch (error: any) {
            console.error(error);
            res = error.response.data;
        }
        return res;
    },
};
